import React, { useContext, useState } from "react";
import styles from "./Hotline.module.scss";
import { AppContext } from "../../context/AppContext";
import { ReactComponent as CloseIcon } from "../../assets/close.svg";

export default function Hotline({ isVisible }) {
  const ctx = useContext(AppContext);
  const { toggleModal } = ctx;

  if (isVisible) {
    return (
      <div onClick={() => toggleModal(null)} className={styles.modal}>
        <CloseIcon className={styles.close} onClick={() => toggleModal(null)} />

        <iframe
          className={styles.iframe}
          src="https://ukraine-nft.d3r299tmsj3zbk.amplifyapp.com/hotline?apcid=00622896ec438334c16d9100&email=frankoprifti@gmail.com"
        ></iframe>
      </div>
    );
  } else {
    return null;
  }
}
